import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAbuseReport } from "../../api/AbuseApi";
import { AbuseReport, AbuseQuery, AbuseResult } from "../../types/abuse";
interface ReportState {
  query: AbuseQuery;
  result: AbuseResult;
  status: "idle" | "loading" | "ready" | "error";
  requestId?: string;
}
const initialReport = (): ReportState => ({
  query: { page: 1, perPage: 25 },
  result: { data: [], count: 0, page: 1, perPage: 25, totalPages: 0 },
  status: "idle",
});
const initialState: Record<AbuseReport, ReportState> = {
  blocked: initialReport(),
  incidents: initialReport(),
};
export const fetchAbuseReport = createAsyncThunk(
  "abuse/fetch",
  async ({ report, query }: { report: AbuseReport; query: AbuseQuery }) =>
    getAbuseReport(report, query)
);
export const abuseSlice = createSlice({
  name: "abuse",
  initialState,
  reducers: {
    setAbuseQuery(
      state,
      action: PayloadAction<{ report: AbuseReport; query: AbuseQuery }>
    ) {
      state[action.payload.report].query = action.payload.query;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAbuseReport.pending, (state, action) => {
      const report = state[action.meta.arg.report];
      report.status = "loading";
      report.requestId = action.meta.requestId;
    });
    builder.addCase(fetchAbuseReport.fulfilled, (state, action) => {
      const report = state[action.meta.arg.report];
      if (report.requestId !== action.meta.requestId) return;
      report.result = action.payload;
      report.status = "ready";
    });
    builder.addCase(fetchAbuseReport.rejected, (state, action) => {
      const report = state[action.meta.arg.report];
      if (report.requestId === action.meta.requestId) report.status = "error";
    });
  },
});
export const { setAbuseQuery } = abuseSlice.actions;
